<template>
  <div id="vlCardBackground">
    <slot />
  </div>
</template>
<script>
export default {
  props: ["title"],
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#vlCardBackground {
  background: #242527 0% 0% no-repeat padding-box;
  opacity: 1;
  border-radius: 20px;
  width: 100%;
  overflow: hidden;
  color: $mf_ft_color_white;
}
</style>
